<template>
  <div class="dev-pagination">
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      hide-on-single-page
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 0,
    },
    // 主动刷新，更改true false即可
    change: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 0,
    };
  },
  mounted() {
    this.initPage();
    this.currentChange(1);
  },
  methods: {
    initPage() {
      if (this.total != 0) {
        let input = document
          .getElementsByClassName("el-pagination__jump")[0]
          .getElementsByClassName("el-pagination__editor")[0];

        document.getElementsByClassName("el-pagination__jump")[0].innerHTML =
          "";

        var jump = document.createTextNode("跳至");
        document
          .getElementsByClassName("el-pagination__jump")[0]
          .appendChild(jump);

        document
          .getElementsByClassName("el-pagination__jump")[0]
          .appendChild(input);

        var page = document.createTextNode("页");
        document
          .getElementsByClassName("el-pagination__jump")[0]
          .appendChild(page);
      }
    },
    // 初始化分页组件
    currentChange(value) {
      this.currentPage = value;
    },
  },
  watch: {
    // 页码变化回调
    // pageSize: 页面大小
    // current: 第几页
    currentPage(val) {
      let pageInfo = {
        pageSize: this.pageSize,
        current: val,
      };
      // 刷新页面后平滑滚动至顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$emit("currentChange", pageInfo);
    },
    // 主动刷新分页
    change() {
      let pageInfo = {
        pageSize: this.pageSize,
        current: 1,
      };
      this.$emit("currentChange", pageInfo);
    },
  },
};
</script>

<style lang="less">
.dev-pagination {
  width: 100%;
  display: flex;
  justify-content: center;

  .el-pagination {
    padding: 0;

    .el-pagination__jump {
      margin-left: 3px;
      height: 32px;
      line-height: 32px;

      .el-pagination__editor {
        margin: 0 8px;
        padding: 0;
        width: 48px;

        .el-input__inner {
          height: 32px;
        }
      }
    }

    button {
      margin: 0 4px !important;
      border-radius: 4px !important;
      width: 32px;
      height: 32px;
      color: #555665;
      background: #f7f7fc;
    }

    .el-pager {
      .active {
        background: #555666 !important;
        font-weight: bold;
      }

      .active:hover {
        color: #ffffff !important;
      }

      li {
        margin: 0 4px !important;
        border-radius: 4px !important;
        width: 32px;
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        font-weight: 400;
        background: #f7f7fc;
      }

      li:hover {
        color: #222226 !important;
        font-weight: bold;
      }
    }
  }
}
</style>